import React from 'react';
import Seo from '../components/Seo';
import { companyProfile } from '../content/siteContent';

const approachPoints = [
  'Real-world skill development',
  'Industry-relevant training',
  'Practical implementation over theory',
  'Long-term growth and sustainability'
];

const values = [
  'Integrity - Transparent and honest in everything we do',
  'Quality - Delivering high standards in every service',
  'Innovation - Adapting and evolving with modern trends',
  'Commitment - Focused on client success and satisfaction',
  'Growth Mindset - Continuous learning and improvement'
];

const whyVedanskrix = [
  'One platform for IT, career, and global services',
  'Practical and industry-focused approach',
  'Customized solutions, not generic packages',
  'Dedicated support and guidance',
  'Focus on real results, not just promises'
];

function About() {
  return (
    <div className="inner-page about-page">
      <Seo
        title="About Vedanskrix Web LLP | Ahmedabad Service Brand"
        description="Learn about Vedanskrix Web LLP, an Ahmedabad-based brand offering digital services, visa guidance, job placement, and growth-focused support."
        keywords={[
          'Vedanskrix Web LLP Ahmedabad',
          'about Vedanskrix',
          'Ahmedabad service company',
          'digital and support services Gujarat',
          'website development company Ahmedabad',
          'visa and career support company'
        ]}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'AboutPage',
          name: 'About Vedanskrix Web LLP',
          url: `${companyProfile.websiteUrl}/about`,
          description: 'About page for Vedanskrix Web LLP and its technology, visa, and career-focused services.'
        }}
      />

      <section className="about-banner">
        <img src="/aboutus.png" alt="About Vedanskrix" className="about-banner-image" />
        <div className="about-banner-badge">
          <span className="about-banner-dot" />
          <h1>About Us</h1>
        </div>
      </section>

      <section className="about-content">
        <div className="about-copy">
          <p>
            Vedanskrix is a forward-thinking organization dedicated to empowering individuals and
            businesses through integrated solutions in technology, career development, and global
            opportunities. In today&apos;s fast-changing and competitive environment, success
            requires more than just knowledge. It requires the right direction, practical skills,
            and access to opportunities. At Vedanskrix, we focus on delivering exactly that.
          </p>

          <p>
            We offer a comprehensive range of services including IT solutions, website and
            application development, job placement support, academic seminars, faculty services,
            and visa consultancy. Our approach is practical, execution-focused, and aligned with
            real industry demands. Whether it is helping businesses build scalable digital systems,
            guiding students toward career clarity, or supporting individuals in achieving
            international goals, we ensure every service delivers measurable value.
          </p>

          <section className="about-copy-section">
            <h2>Our Approach</h2>
            <p>
              What sets Vedanskrix apart is our commitment to a result-driven and personalized
              approach. We do not believe in generic solutions. Every client, student, or
              organization we work with has unique needs, and we tailor our strategies
              accordingly.
            </p>
            <ul>
              {approachPoints.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <p>Our goal is not just to provide services, but to create real impact.</p>
          </section>

          <section className="about-copy-section">
            <h2>Our Expertise</h2>
            <p>
              Our team consists of experienced professionals, industry trainers, and consultants
              who bring both technical knowledge and practical experience. We combine expertise in
              technology, education, and global consulting to deliver well-rounded solutions.
            </p>
            <p>
              We continuously adapt to changing industry trends, ensuring that our clients always
              stay ahead in a competitive landscape.
            </p>
          </section>

          <section className="about-copy-section">
            <h2>Our Mission</h2>
            <p>
              Our mission is to create a powerful ecosystem where technology, education, and
              global opportunities come together. We aim to empower individuals with the skills
              they need, support businesses with innovative solutions, and connect talent with the
              right opportunities.
            </p>
          </section>

          <section className="about-copy-section">
            <h2>Our Vision</h2>
            <p>
              Our vision is to become a trusted and recognized name in delivering career-focused,
              technology-driven, and globally connected solutions. We strive to build a future
              where individuals and organizations can grow without limitations.
            </p>
          </section>

          <section className="about-copy-section">
            <h2>Our Values</h2>
            <ul>
              {values.map((value) => (
                <li key={value}>{value}</li>
              ))}
            </ul>
          </section>

          <section className="about-copy-section">
            <h2>Why Vedanskrix?</h2>
            <ul>
              {whyVedanskrix.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
          </section>
        </div>
      </section>
    </div>
  );
}

export default About;
